import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Base URL for API
const BASE_URL = `${API_URL}/finalCategories`;

// Async thunks
export const fetchCategories = createAsyncThunk('finalCategory/fetchAll', async (id) => {
  const response = await axios.get(`${BASE_URL}/${id}`);
  return response.data;
});

export const createCategory = createAsyncThunk('finalCategory/create', async (category) => {
  const response = await axios.post(BASE_URL, category);
  return response.data;
});

export const updateCategory = createAsyncThunk('finalCategory/update', async ({ id, category }) => {
  const response = await axios.put(`${BASE_URL}/${id}`, category);
  return response.data;
});

export const deleteCategory = createAsyncThunk('finalCategory/delete', async (id) => {
  await axios.delete(`${BASE_URL}/${id}`);
  return id;
});

// Slice
const finalCategorySlice = createSlice({
  name: 'finalCategory',
  initialState: {
    categories: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.categories.push(action.payload);
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        const index = state.categories.findIndex((cat) => cat.id === action.payload.id);
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter((cat) => cat.id !== action.payload);
      });
  },
});

export default finalCategorySlice.reducer;
